import adminDomains from 'data/adminDomains';

export default adminDomains.includes(window.location.hostname);
